export enum DataPlayersAction {
  UPDATE_DATA_PLAYER = 'UPDATE_DATA_PLAYER',
  REPLACE_DATA_PLAYERS = 'REPLACE_DATA_PLAYERS',
  REPLACE_DATA_PLAYERS_PLAYER_PRACTICES = 'REPLACE_DATA_PLAYERS_PLAYER_PRACTICES',
  REPLACE_DATA_PLAYERS_PLAYER_GAMES = 'REPLACE_DATA_PLAYERS_PLAYER_GAMES',
}

interface ReplaceDataPlayersType {
  type: DataPlayersAction.REPLACE_DATA_PLAYERS,
  players: DataPlayersState
}

interface ReplaceDataPlayerType {
  type: DataPlayersAction.UPDATE_DATA_PLAYER,
  player: DataPlayer
}

interface ReplaceDataPlayersPlayerPractices {
  type: DataPlayersAction.REPLACE_DATA_PLAYERS_PLAYER_PRACTICES,
  playerId: string,
  practices: DataPlayerEventsPractices
}

interface ReplaceDataPlayersPlayerGames {
  type: DataPlayersAction.REPLACE_DATA_PLAYERS_PLAYER_GAMES,
  playerId: string,
  games: DataPlayerEventsGames
}

export type DataPlayersActionTypes = ReplaceDataPlayersType | ReplaceDataPlayerType | ReplaceDataPlayersPlayerPractices | ReplaceDataPlayersPlayerGames;

export type MetaDataPlayer = {
  name: string,
  playerId: string,
  position: string,
  positionGroup?: string, // all of the undefined is cause' BallMetricsModal
  status?: string,
  sbeid?: string,
  teamId: string,
  jersey: string,
  eid?: string
};

export type MetaDataPlayerSearched = {
  name: string,
  nid: string,
  position: string,
  positionGroup: string,
  status: string,
  sbeid: string,
  teamId: string,
  jersey: string,
  eid: string,
  metrics: { [key: string]: any }
};

// TODO: Correct the type of practices and games
export type DataPlayerEventsGames = any[];
export type DataPlayerEventsPractices = any[];

export type DataPlayer = {
  meta: MetaDataPlayer,
  metrics: { [key: string]: any },
  events?: { // undefined cause BallMetrics Modal
    games: DataPlayerEventsGames,
    practices: DataPlayerEventsPractices
  }
};

export type DataPlayersState = { [key: string]: DataPlayer };

export type DataPlayers = DataPlayer[];